(function () {
  const store = window.ScrubLabTeams && window.ScrubLabTeams.store;
  const root = document.querySelector('[data-team-builder]');

  if (!store || !root) return;

  store.root = root;

  store.els = {
    addMember: root.querySelector('[data-add-member]'),
    members: root.querySelector('[data-members]'),
    itemCount: root.querySelector('[data-item-count]'),
    discountMessage: root.querySelector('[data-discount-message]'),
    progressBar: root.querySelector('[data-progress-bar]'),
    drawer: root.querySelector('[data-drawer]'),
    drawerContent: root.querySelector('[data-drawer-content]')
  };

  store.bindEvents();
  store.render();
  store.initialiseCatalogueFilters();

  console.log('Scrub Lab Teams loaded', store.state);
})();